import normalize from "json-api-normalizer";
import omit from "lodash/omit";
import queryString from "query-string";
import { batch } from "react-redux";

import { GET, PATCH, POST } from "../../util/apiHelpers";

import { mapKeysToCamelCase, mapKeysToSnakeCase } from "../../util/formatHelpers";
import { receiveCandidates } from "../shared/candidateActions";
import { fetchContractSuccess } from "../shared/contractActions";
import { receiveJobcasts } from "../shared/jobcastActions";
import {
  fetchPayPeriodsStart,
  fetchPayPeriodSuccess,
  fetchPayPeriodsError,
  receivePayPeriods,
  receivePayPeriodIsApproving,
  invalidatePayPeriodsTable,
} from "../shared/payPeriodActions";
import { refetchLeftDrawerCounts } from "../shared/uiActions";

export function fetchPayPeriods(params = {}) {
  const { candidateId } = params;

  const baseUrl = candidateId
    ? `/api/v3/recruiter/candidates/${candidateId}/pay_periods`
    : "/api/v3/recruiter/pay_periods";

  const queryStr = queryString.stringify(mapKeysToSnakeCase(omit(params, ["candidateId"])));

  const url = queryStr ? `${baseUrl}?${queryStr}` : baseUrl;

  return (dispatch) => {
    dispatch(fetchPayPeriodsStart());

    return GET(url)
      .then((response) => {
        const normalized = normalize(response.data);

        batch(() => {
          dispatch(receiveCandidates(normalized.candidate));
          dispatch(receiveJobcasts(normalized.jobcast));
          dispatch(receivePayPeriods(normalized.payPeriod));
          dispatch(fetchContractSuccess(normalized.contract));
        });

        return {
          items: normalized.payPeriod,
          metaData: mapKeysToCamelCase(response.data.meta),
          contracts: normalized.contract,
          candidates: normalized.candidate
        };
      })
      .catch((error) => dispatch(fetchPayPeriodsError(error)));
  };
}

export function updatePayPeriod(payPeriodId, values) {
  const url = `/api/v3/recruiter/pay_periods/${payPeriodId}`;

  return (dispatch) =>
    PATCH(url, values).then((response) => {
      const normalized = normalize(response.data);
      dispatch(fetchPayPeriodSuccess(normalized.payPeriod));
      dispatch(refetchLeftDrawerCounts());
    });
}

export function approvePayPeriod(payPeriodId, edited_at, populate_ukg_timesheet = false, allocations) {
  const url = `/api/v3/recruiter/pay_periods/${payPeriodId}/approve`;

  return (dispatch) => {
    dispatch(receivePayPeriodIsApproving(true));

    return PATCH(url, { edited_at, populate_ukg_timesheet, allocations }).then((response) => {
      const normalized = normalize(response.data);
      dispatch(fetchPayPeriodSuccess(normalized.payPeriod));
      dispatch(refetchLeftDrawerCounts());
      dispatch(receivePayPeriodIsApproving(false));
    });
  };
}

export function disputePayPeriod(payPeriodId, dispute_explanation, edited_at) {
  const url = `/api/v3/recruiter/pay_periods/${payPeriodId}/dispute`;

  return (dispatch) =>
    PATCH(url, { dispute_explanation, edited_at }).then((response) => {
      const normalized = normalize(response.data);
      dispatch(fetchPayPeriodSuccess(normalized.payPeriod));
      dispatch(refetchLeftDrawerCounts());
    });
}

export function reportTimesheetCorrection(payPeriodId, correctionReason, options = {}) {
  const url = `/api/v3/recruiter/pay_periods/${payPeriodId}/report_correction`;

  const reportCorrectionPayload = {
    correction_reason: correctionReason
  };
  if (options.approved !== undefined) {
    reportCorrectionPayload.approved = options.approved;
  }

  return (dispatch) => {
    return POST(url, {
      report_correction: reportCorrectionPayload
    }).then((response) => {
      const normalized = normalize(response.data);
      dispatch(fetchPayPeriodSuccess(normalized.payPeriod));
      dispatch(invalidatePayPeriodsTable());
      dispatch(refetchLeftDrawerCounts());
      return response;
    });
  };
}

export function reportTimesheetCorrectionAsDispute(payPeriodId, correctionReason) {
  const url = `/api/v3/recruiter/pay_periods/${payPeriodId}/report_correction_as_dispute`;

  return (dispatch) => {
    return POST(url, {
      report_correction: { correction_reason: correctionReason }
    }).then((response) => {
      const normalized = normalize(response.data);
      dispatch(fetchPayPeriodSuccess(normalized.payPeriod));
      dispatch(invalidatePayPeriodsTable());
      dispatch(refetchLeftDrawerCounts());
      return response;
    });
  };
}
